<template>
  <div ref="nps"></div>
</template>

<script>
import { noNPSInThisRoutes } from '@/util/helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NPS',

  computed: {
    ...mapGetters(['user']),
  },

  watch: {
    $route({ name }) {
      this.checkShowNPS(name)
    },
  },

  methods: {
    ...mapActions(['fetchUser']),

    checkShowNPS(route) {
      if (route === null || noNPSInThisRoutes.includes(route)) return

      this.fetchUser()
        .then(() => {
          const token = localStorage.getItem('access_token')
          return JSON.parse(window.atob(token?.split('.')[1]))
        })
        .then((jwt) => {
          this.isHost = jwt.authorities.includes('ROLE_HOST')

          window.amplData = {
            name: this.user?.name,
            email: jwt?.user_name,
            created_at: Math.round(new Date() / 1000),
            survey: this.isHost ? this.hostSurvey : this.defaultSurvey,
          }
        })
        .then(() => window.AmplSurvey?.run('run'))
    },
  },

  data() {
    return {
      isHost: false,

      defaultSurvey: '62d8545a0219ddf5c9a2ad1c',
      hostSurvey: '62e9610d1bfcf74a1435617d',
    }
  },

  mounted() {
    const userCountry = localStorage.getItem('user_country')
    const onboardingStatus = localStorage.getItem('users_onboard_status')

    if (userCountry !== 'BR') return
    if ( onboardingStatus === 'NO_SERVICE') return

    const npsWrapper = this.$refs.nps
    const nps = document.createElement('script')

    nps.setAttribute('src', 'https://cdn.amplifique.me/amp-nps-sdk-3.0.js')
    npsWrapper.appendChild(nps)

    this.checkShowNPS(this.$route.name)
  },
}
</script>
